import msDeal from './msDeal';
import _random from 'lodash/random';
import gameState from '../redux/gameState';

export function makeLayout(s) {
  const easiest = [
    25904, 5152, 11987, 13464, 9998, 62090, 1529, 38168, 41426, 41993, 48995, 3250, 48800, 54477, 58573, 61556, 5300,
    17871, 59641, 41293, 43306, 53488, 18427, 31316, 52255, 14624, 18150, 49676, 50203, 1081, 15140, 30584, 49487,
    50534, 58441, 2514, 12411, 17772, 37509, 1150, 3225, 5213, 7807, 21657, 28856, 5877, 11863, 62487, 7018, 21900,
    31185, 33624, 19951, 30418, 30849, 45580, 6893, 13532, 18026, 43073, 48689, 52573, 57355, 63675, 2508, 27853, 32016,
    38770, 43196, 57435, 14826, 30755, 63249, 892, 4929, 5907, 8961, 14014, 61047, 23328, 40441, 8471, 10772, 40041,
    6749, 15196, 27121, 33710, 41747, 47917, 56070, 60306, 5814, 30329, 164, 7058, 49923, 3178, 5055, 22663, 38066,
    42094, 52331, 61206, 13214, 25001, 33949, 59974, 8355, 57035, 20533, 24919, 47774, 26719, 40616, 47824, 48675,
    12676, 7167, 46561, 63880, 37913, 1012, 12392, 51232, 62799, 24176, 34898,

    164, 892, 1012, 1081, 1150, 1529, 2508, 2514, 3178, 3225, 3250, 4929, 5055, 5152, 5213, 5300, 5814, 5877, 5907,
    6749, 6893, 7018, 7058, 7167, 7807, 8355, 8471, 8961, 9998, 10772, 11863, 11987, 12392,

    12411, 12676, 13214, 13464, 13532, 14014, 14624, 14826, 15140,

    15196, 17772, 17871, 18026, 18150, 18427, 19951, 20533, 21657,

    21900, 22663, 23328, 24176, 24919, 25001, 25904, 26719, 27121,

    27853, 28856, 30329, 30418, 30584, 30755, 30849, 31185, 31316,
  ];

  let seed = s || easiest[_random(0, easiest.length - 1)];

  const unsolvable = [-1, 11982, 146692, 186216, 455889, 495505, 512118, 517776, 781948];

  while (unsolvable.includes(seed)) {
    seed = _random(0, 32000);
  }

  const laid = msDeal(seed);

  return { gameState: { ...gameState, laid }, seed };
}
